"use strict";

exports.__esModule = true;
exports.AdvancedDataTableColumnElement = AdvancedDataTableColumnElement;
// Rendering for this is currently controlled by the AdvancedDataTable and not called on this element.
// This is here because we use the editor to configure a column as if it were it's own widget
function AdvancedDataTableColumnElement() {
  return null;
}